<template lang="pug">
div
  el-button(type="primary", @click="editVue") 编辑
  //- el-button(@click="importVue") 导入
  el-button(@click="exportVue") 导出
  el-button(@click="openScript") 外部资源
</template>
<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { saveAs } from "file-saver";
import asyncCom from "@/CommonDP/commons/asyncCom";
import { subFormBus } from "../utils/panel-setting/subFormBus";
export default {
  mixins: [settingMixin],
  inject: ["serverFieldList"],
  data() {
    return {};
  },
  computed: {
    ...mapVFOptions("vueTemplate", "vueScript", "vueStyle", "externalScripts"),
    fieldList() {
      return subFormBus.isSubformJyht ? subFormBus.list : this.serverFieldList;
    },
    exportVueRaw() {
      const { vueTemplate, vueScript, vueStyle } = this;
      const scriptTxt = "script"; // 为了应付奇怪的解析规则
      return `<template>
${vueTemplate.trim()}
</template>
<${scriptTxt}>
export default ${vueScript.trim()}
</${scriptTxt}>
<style>
${vueStyle.trim()}
</style>`;
    }
  },
  methods: {
    async openScript() {
      const externalScripts = this.externalScripts || [];
      const inputValue = externalScripts.join("\n");
      const { value = "" } = await this.$prompt("请输入地址,多条使用换行隔开", "外部资源", { inputType: "textarea", inputValue: inputValue });
      const newJsList = value
        .split("\n")
        .map((str) => str.trim())
        .filter((str) => str);
      this.externalScripts = newJsList;
    },
    exportVue() {
      const blob = new Blob([this.exportVueRaw], { type: "text/plain;charset=utf-8" });
      saveAs(blob, `${this.optionModel.name}.vue`);
    },
    async parseComponent(vueCode) {
      const { parseComponent } = await import("vue-template-compiler");
      const { template, script, styles } = parseComponent(vueCode);
      const sc = script.content || "";
      const keyStr = "export default";
      const dfIndex = sc.indexOf(keyStr);
      this.vueTemplate = template.content;
      this.vueScript = sc.substring(dfIndex + keyStr.length);
      this.vueStyle = styles.map(({ content }) => content).join("\n");
    },
    async editVue() {
      const {
        fieldList,
        optionModel: { name, label }
      } = this;
      const { default: editor } = await import("./editor.vue");
      const code = await asyncCom(editor, { code: this.exportVueRaw, fieldKey: name, fieldLabel: label, fieldList });
      this.parseComponent(code);
    }
  }
};
</script>
